import { DropdownSelectOption, ThemeColours } from '@keplerco/core';
import { CompletionStatus } from '../../enums';
import { SortByOption, SortByOptionDescription } from '../../enums/sort-by-option';

export function getBorderColorByCompletionStatus(status: CompletionStatus): ThemeColours {
  switch (status) {
    case CompletionStatus.Completed:
      return 'g_1';
    case CompletionStatus.InProgress:
      return 'a_1';
    case CompletionStatus.NotStarted:
      return 'borders';
    default:
      return 'default_1';
  }
}

export const yourAssessmentSortByOptions: DropdownSelectOption[] = [
  { value: SortByOption.MostRecentAssigned, label: SortByOptionDescription.MostRecentAssigned },
  { value: SortByOption.RecentlyCompleted, label: SortByOptionDescription.RecentlyCompleted }, // TODO add on BE
  { value: SortByOption.ScoreHighToLow, label: SortByOptionDescription.ScoreHighToLow },
];
